

import { Component, Input, TemplateRef, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'; // ✅ import

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  standalone: true,
  imports: [CommonModule, TooltipModule, NgxSkeletonLoaderModule]
})
export class CardComponent {
  @Input() title!: string;
  @Input() value: number | string = 0;
  @Input() icon!: string;
  @Input() percentage?: number;
  @Input() tooltip?: string | TemplateRef<any>;
  @Input() container: string = 'body';
  @Input() placement: 'top' | 'bottom' | 'left' | 'right' = 'top';
  @Input() containerClass: string = 'tooltipContainer';
  @Input() adaptivePosition: boolean = false;
  @Input() isSelected: boolean = false;
  @Input() tooltipPosition: 'top' | 'bottom' | 'left' | 'right' = 'top';
  @Input() loading: boolean = false;
  @Input() showPercent: boolean = true;
  @Input() showTooltip: boolean = true;
  
  @Output() cardClick = new EventEmitter<void>();
  onCardClick() {
    if (!this.loading) {
      this.cardClick.emit();
    }
  }


}
